import React from "react"
import PropTypes from "prop-types"
import SeoHead from "../../Scripts/SeoHead"
import GtmBody from "../../Scripts/Gtm.Body"

const ScriptWrapper = props => {
  const { seoHead, preloadComp, slug } = props

  return (
    <>
      <SeoHead {...seoHead} slug={slug} preloadComp={preloadComp} />
      <GtmBody />
    </>
  )
}

ScriptWrapper.propTypes = {
  seoHead: PropTypes.object,
  preloadComp: PropTypes.object,
  slug: PropTypes.string
}

export default ScriptWrapper
